import React, { useEffect, useState } from "react";
import { getBranchCampaignName, getLinkData, BranchIOLinkData } from "web/script/utils/branch-io";
import { useClickTracker } from "web/react/hooks/use-click-tracker/use-click-tracker";
import Button from "web/react/components/button/button";
import analytics from "web/script/analytics/analytics";

interface BranchLinkProps {
    branchLink: string;
    className?: string;
    children?: JSX.Element;
    eventLabel?: string;
    primaryButton?: boolean;
    title: string;
    appDeepLinkURL?: URL;
    financialIncentiveWebviewToken?: string;
}

function BranchLink({
    title,
    className,
    children,
    eventLabel,
    branchLink,
    primaryButton,
    appDeepLinkURL,
    financialIncentiveWebviewToken,
}: BranchLinkProps): JSX.Element {
    let trackedClick = useClickTracker("web_to_app", "click", eventLabel, true, {
        campaign_name: getBranchCampaignName(branchLink),
    });

    const [branchHref, setBranchHref] = useState<string>(branchLink);

    useEffect(() => {
        function updateHref(): void {
            const branchReferralLink = new URL(branchLink);
            const branchIOLinkData: BranchIOLinkData = getLinkData(
                appDeepLinkURL,
                financialIncentiveWebviewToken
            );
            for (const branchDataProperty in branchIOLinkData) {
                branchReferralLink.searchParams.set(
                    branchDataProperty,
                    branchIOLinkData[branchDataProperty]
                );
            }

            setBranchHref(branchReferralLink.toString());
        }

        updateHref();
        analytics.on("pageViewIdChanged", updateHref);
        return function cleanup(): void {
            analytics.off("pageViewIdChanged", updateHref);
        };
    }, [branchLink, appDeepLinkURL, financialIncentiveWebviewToken]);

    if (primaryButton) {
        return (
            <Button
                onClick={trackedClick}
                styleType="cta"
                href={branchHref}
                disabled={false}
                fullWidth={true}
                fullHeight={false}
                openInNewTab={false}
                className={className ? className : ""}
                aria-label={title}
            >
                {title}
            </Button>
        );
    }

    return (
        <a
            onClick={trackedClick}
            className={className}
            href={branchHref}
            title={title}
            aria-label={title}
        >
            {children}
        </a>
    );
}

export default BranchLink;
